import {
  Box,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  CircularProgress,
} from '@mui/material'
import React, { useState } from 'react'
import DownloadIcon from '@mui/icons-material/Download'
import { dealershipBrandOptions } from '../../constants/dealershipBrands'
import moment from 'moment'
import { useExportWarrantyRegistration } from '../../hooks/api/warranty'
import { useSnackbar } from 'notistack'

const ExportFileDialog = ({ open, setOpen }) => {
  const [brands, setBrands] = useState([])

  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
  const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'))

  const { mutateAsync: get, isLoading } = useExportWarrantyRegistration()
  const { enqueueSnackbar } = useSnackbar()

  const handleExportFile = async () => {
    try {
      const res = await get({ startDate, endDate, brands: brands?.map(({ id }) => id)?.join(',') })
      const url = URL.createObjectURL(res.data)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `HT Tyre Warranty.xlsx`)
      document.body.appendChild(link)
      link.click()
      enqueueSnackbar(`Exported`, {
        variant: 'success',
      })
      setOpen(false)
    } catch (e) {
      enqueueSnackbar(`Failed to export data`, {
        variant: 'error',
      })
    }
  }
  return (
    <Dialog maxWidth='sm' fullWidth open={open}>
      <DialogTitle>Export Data</DialogTitle>
      <DialogContent dividers>
        <Box gridGap={12} display='grid'>
          <Autocomplete
            multiple
            value={brands}
            onChange={(_, value) => {
              setBrands(value)
            }}
            options={dealershipBrandOptions}
            getOptionLabel={(option) => option?.label}
            renderInput={(params) => <TextField {...params} label='Filter Brands' />}
          />
          <Box display='flex' mt={3}>
            <TextField
              label='Start Date'
              type='date'
              fullWidth
              variant='outlined'
              defaultValue={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            <TextField
              label='End Date'
              type='date'
              fullWidth
              variant='outlined'
              defaultValue={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              style={{ marginLeft: '15px' }}
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={() => setOpen(false)} disabled={isLoading}>
          CANCEL
        </Button>
        <Button
          variant='contained'
          color='primary'
          startIcon={<DownloadIcon />}
          endIcon={isLoading && <CircularProgress size='1rem' />}
          onClick={handleExportFile}
          disabled={isLoading}
        >
          EXPORT
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ExportFileDialog
